import {
  isSafari as isDesktopSafari,
  isMobileSafari,
} from 'react-device-detect';

const isSafari = isDesktopSafari || isMobileSafari;

export const MIN_AUDIO_DURATION = 1;
export const MAX_AUDIO_DURATION = 60;

export const acceptedFileTypes = {
  'audio/flac': ['.flac'],
  'audio/mpeg': ['.mp3'],
  // 'audio/mpeg' is the MIME type for .mp3. For more info: https://www.rfc-editor.org/rfc/rfc3003
  'audio/wav': ['.wav'],
  'audio/m4a': ['.m4a'],

  'video/*': [],
  // we need to explicitly add .3gp otherwise the files won't show up in the file picker
  'video/3gpp': ['.3gp'],

  ...(isSafari
    ? null
    : {
        'audio/ogg': ['.ogg'],
      }),
};
